<div class="border-0 px-4 py-1 scroll-container" ref="ActionManagement">
  <p class="page-title mt-3 fs-6 fw-bold">Actions Management</p>

  <!-- Loading Spinner -->
  <div v-if="loading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div class="row" v-if="!loading">
    <div class="col-md-4">
      <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
        <div class="card-body d-flex align-items-center gap-3 py-3 px-3 justify-content-between">
          <div class="d-flex flex-column justify-content-center text-start">
            <p class="mb-1 text-xs text-white">Total Actions</p>
            <p class="m-0 fw-bold text-white">{{ actions.length }}</p>
          </div>
          <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
            <i class="fas fa-tasks fa-lg text-primary-blue"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Actions Table -->
  <div class="glassy-table rounded-lg mt-4 border-0 shadow" v-if="!loading">
    <div class="card-body">
      <div class="d-block text-end">
        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow mb-2" data-bs-toggle="modal"
          data-bs-target="#create_actions_modal">
          Create Action
        </button>
      </div>
      <GlobalTable v-if="actions.length > 0" :headers="['ID', 'Action Name', 'Description', 'Date Created']"
        :data="actions" :table_id="'actions_table'">
        <template #actions="{ row }">
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2" data-bs-toggle="modal"
            data-bs-target="#update_action_modal" @click="set_edit_action(row)">
            Edit
          </button>
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow" data-bs-toggle="modal"
            data-bs-target="#delete_action_modal" @click="set_delete_action(row.id)">
            Delete
          </button>
        </template>
      </GlobalTable>

      <div v-else class="text-center py-4">
        <p class="text-muted">No actions found. Create your first action!</p>
      </div>
    </div>
  </div>
</div>

<!-- Create Action Modal -->
<teleport to="body">
<div class="modal fade" id="create_actions_modal" tabindex="-1" aria-labelledby="create_actions_label"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_actions_label">Create Action</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3 d-flex flex-column">
          <label for="action_name" class="modal-form-label form-label text-start text-xxs">Action Name:</label>
          <input type="text" id="action_name" v-model="action_name"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Please enter action name">
        </div>

        <div class="modal-form-group form-group mb-3 d-flex flex-column">
          <label for="action_description" class="modal-form-label form-label text-start text-xxs">Action
            Description:</label>
          <input type="text" id="action_description" v-model="action_description"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Please enter a description for the action">
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow-sm" @click="save_action_created"
          :disabled="!action_name.trim() || !action_description.trim()" data-bs-dismiss="modal">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Edit Action Modal -->
<teleport to="body">
<div class="modal fade" id="update_action_modal" tabindex="-1" aria-labelledby="update_action_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="update_action_label">Update Action</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3 d-flex flex-column">
          <label for="update_action_name" class="modal-form-label form-label text-start text-xxs">Action Name:</label>
          <input type="text" id="update_action_name" v-model="update_action_name"
            class="modal-form-control form-control rounded-small p-2 shadow-sm text-xxs"
            placeholder="Please enter action name">
        </div>

        <div class="modal-form-group form-group mb-3 d-flex flex-column">
          <label for="update_action_description" class="modal-form-label form-label text-start text-xxs">Action
            Description:</label>
          <input type="text" id="update_action_description" v-model="update_action_description"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Please enter a description for the action">
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs" @click="update_actions"
          :disabled="!update_action_name.trim() || !update_action_description.trim()" data-bs-dismiss="modal">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Delete Confirmation Modal -->
<teleport to="body">
<div class="modal fade" id="delete_action_modal" tabindex="-1" aria-labelledby="delete_action_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="delete_action_label">Delete Action</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="text-xxs">Are you sure you want to delete this action? This action cannot be undone.</p>
      </div>
      <div class="modal-footer border-0 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs" @click="delete_action"
          data-bs-dismiss="modal">
          Delete
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>